import React from 'react';
import './ScrollArrowButton.css';

const ScrollArrowButton = ({ targetId }) => {
  const handleClick = () => {
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <button className='scroll-arrow-button' onClick={handleClick} aria-label='Scroll down'>
      <svg viewBox='0 0 24 24'>
        <path d='M12 5v14M5 12l7 7 7-7' strokeLinecap='round' strokeLinejoin='round' />
      </svg>
    </button>
  );
};

export default ScrollArrowButton;
